import { z } from 'zod';

export const CashbackShareValue = z.number().min(50).max(100);
export type CashbackShareValue = z.infer<typeof CashbackShareValue>;
